var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg020Ux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 561,
    viewBox: "0 0 1000 561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #000;\r\n        stroke-width: 20px;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,40H165V314c0,60.589,30.7,98,78,98s89-34.445,89-100V41H452V330c0,97.283-62.3,191-212,191C110.661,521,42,429.112,42,327V128"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493,40H632l86,138L805,41H936L786,269,947,513H805L715,367,626,513H485L645,275,550,128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg020Ux);
export default __webpack_public_path__ + "static/media/020_UX.02fee914feebeb4b7e8fe82ed2169323.svg";
export { ForwardRef as ReactComponent };